import {
  Filter
} from '../common/filter';

require('./footer.component.scss');

class FooterController {
  constructor(
    $scope,
    CurrentFilterService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    FiltersService,
    CurrentFilterDataService,
    CancelersService,
    LayoutService,
    AggregateDataService,
    ServerInformationService,
    FilterEditorService,
    AdminModalService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.CancelersService = CancelersService;
    this.locLabel = Filter.locLabel;
    this.AggregateDataService = AggregateDataService;
    this.ServerInformationService = ServerInformationService;
    this.FilterEditorService = FilterEditorService;
    this.AdminModalService = AdminModalService;
    this.timeLoad = null;

    $scope.$watch('$ctrl.isLoading', (newValue, oldValue) => {
      if (newValue && !oldValue) {
        this.timeLoad = null;
        this.timeStartLoad = new Date();
      } else if (!newValue && oldValue) {
        this.timeEndLoad = new Date();
        if (this.timeStartLoad) {
          this.timeLoad = (this.timeEndLoad - this.timeStartLoad) / 1000;
        }
      }
    });
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  get updateBtnName() {
    return this.CurrentFilterDataService.needReload ? gettext('Применить') : gettext('Обновить');
  }

  get hddUsage() {
    return this.ServerInformationService.hddUsage;
  }

  get hddAlarm() {
    return this.ServerInformationService.hddAlarm;
  }

  get databaseAlarm() {
    return this.ServerInformationService.databaseAlarm;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  get isEventsLoading() {
    return this.CurrentFilterDataService.filterData.loading ||
      this.CurrentFilterDataService.filterData.loadingMore ||
      this.FiltersService.loading;
  }

  get isLoading() {
    return this.CurrentModelService.loading ||
      this.currentFilter.imageLoading ||
      this.AggregateDataService.loading ||
      this.AggregateDataService.loadingMore ||
      this.FiltersService.loading ||
      this.LayoutService.loading ||
      this.CurrentFilterDataService.isLoading;
  }

  get databaseUsage() {
    return this.ServerInformationService.databaseUsage;
  }

  get clickhouseUsage() {
    return this.ServerInformationService.clickhouseUsage;
  }

  get clickhousePath() {
    return this.ServerInformationService.clickhousePath;
  }

  reload() {
    window.CACHE.reset();
    this.$rootScope.$broadcast('reload');
  }

  cancel() {
    this.AggregateDataService.cancel();
    this.CurrentFilterDataService.filterData.cancel();
  }

  hddStatus() {
    this.AdminModalService.hddStatus();
  }

  databaseStatus() {
    this.AdminModalService.databaseStatus();
  }

  clickhouseStatus() {
    this.AdminModalService.clickhouseStatus();
  }

  editQueryFilter() {
    return this.FilterEditorService.editModal({
      filter: this.filter,
      asNew: false,
      selectFilter: false,
      tabName: 'QueryTab',
    });
  }

  openCuts() {
    this.router.modal = 'cuts-edit';
  }

}

export const FooterComponent = {
  template: require('./footer.component.html'),
  controller: FooterController,
};



// WEBPACK FOOTER //
// ./src/layout/footer.component.js